export enum PortfolioApprovalTagContent {
  EDITS_PENDING_APPROVAL = 'EDITS - PENDING APPROVAL',
  PENDING_APPROVAL = 'PENDING APPROVAL',
  EDITS_REJECTED = 'EDITS - REJECTED',
  NEW_REJECTED = 'REJECTED (EDIT OR REMOVING SOON)'
}
